import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["manageLink", "checkbox", "manageButton", "emptyMessage"]

  declare manageLinkTarget: HTMLElement
  declare hasManageLinkTarget: boolean
  declare checkboxTarget: HTMLInputElement
  declare manageButtonTarget: HTMLElement
  declare hasManageButtonTarget: boolean
  declare emptyMessageTarget: HTMLElement
  declare hasEmptyMessageTarget: boolean

  private questionsObserver: MutationObserver | null = null

  connect() {
    this.observeQuestions()
  }

  disconnect() {
    this.questionsObserver?.disconnect()
  }

  toggle() {
    if (!this.hasManageLinkTarget) return

    const checked = this.checkboxTarget.checked
    this.manageLinkTarget.classList.toggle("hide", !checked)
  }

  private observeQuestions() {
    const questionsContainer = document.getElementById("questions")
    if (!questionsContainer) return

    this.updateQuestionsVisibility(questionsContainer)

    this.questionsObserver = new MutationObserver(() => {
      this.updateQuestionsVisibility(questionsContainer)
    })

    this.questionsObserver.observe(questionsContainer, { childList: true })
  }

  private updateQuestionsVisibility(container: HTMLElement) {
    const hasQuestions = container.querySelectorAll(".question").length > 0

    if (this.hasManageButtonTarget) {
      this.manageButtonTarget.classList.toggle("hide", !hasQuestions)
    }
    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.classList.toggle("hide", hasQuestions)
    }
  }
}
